export enum OrderStatus {
  Placed = 1,
  Preparing = 2,
  Released = 3,
  Served = 4,
  Closed = 5
}
